<template>
  <v-flex
    layout
    row
    align-center
    pl-4
    pr-4
    :class="[
      langEdition !== locale && hintText[locale] && showHint
        ? 'showHintClass'
        : null,
    ]"
  >
    <v-text-field
      @blur="updateHintText"
      v-model="hintText[langEdition]"
      :label="$tc('gameFormCard.options.hints.text', hintId + 1)"
      :hint="langEdition !== locale ? hintText[locale] : null"
      :persistent-hint="showHint"
    >
      <language-translator
        v-if="locale !== langEdition"
        :langEdition="langEdition"
        :textToTranslate="hintText[locale]"
        :type="'hintText'"
        @text-translated="updateTranslatedText"
        slot="append"
      >
      </language-translator>
    </v-text-field>

    <v-tooltip top>
      <template v-slot:activator="{ on }">
        <v-icon
          v-if="possibleToDelete"
          v-on="on"
          color="red"
          class="deleteIcon"
          :class="'pointerClass'"
          @click="deleteHint()"
        >
          mdi-close
        </v-icon>
      </template>
      <span> {{ $t('gameFormCard.options.hints.delete') }} </span>
    </v-tooltip>
  </v-flex>
</template>

<script>
import LanguageTranslator from './LanguageTranslator.vue';

export default {
  name: 'GameMcq',
  components: {
    LanguageTranslator,
  },
  props: {
    hintId: {
      type: Number,
      default: null,
    },
    hint: {
      type: Object,
      default: null,
    },
    possibleToDelete: {
      type: Boolean,
      default: false,
    },
    langEdition: {
      type: String,
      default: null,
    },
    showHint: {
      type: Boolean,
      default: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isCorrect: false,
      hintText: '',
    };
  },
  created() {
    this.hintText = { fr: '', en: '' };
    this.hintText.en = this.hint.text.en;
    this.hintText.fr = this.hint.text.fr;
  },
  watch: {
    hint(newValue) {
      this.hintText = newValue.text;
    },
  },
  methods: {
    updateHintText() {
      if (
        this.hintText[this.langEdition] !== this.hint.text[this.langEdition]
      ) {
        this.$emit(
          'update-hint-text',
          this.hintText[this.langEdition],
          this.hintId
        );
      }
    },
    deleteHint() {
      this.$emit('delete-hint', this.hintId);
    },
    async updateTranslatedText(textTranslated, type) {
      if (textTranslated) {
        if (type === 'hintText') {
          this.hintText[this.langEdition] = textTranslated;
          this.updateHintText();
        }
      }
    },
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
  },
};
</script>

<style lang="sass" scoped>
div.v-input
 width: 300px

.deleteIcon
  max-width: 20px;
  margin-left: 7px;
  margin-right: 10px;

.mcqClass
  margin-top: 0px
  max-height: 66px

.readOnlyClass
  pointer-events: none;

.showHintClass
  margin-bottom: 20px;
</style>
